export default {
  key: "succes",
  Things: "Dinge",
  "Upload Date": "Datum des Hochladens",
  Duration: "Dauer",
  Features: "Merkmale",
  "Edit Image": "Bild bearbeiten",
  Title: "Titel",
  Description: "Beschreibung",
  "New Image": "Neues Bild",
  Image: "Bild",
  Images: "Bilder",
  Tags: "Stichworte",
  "Save & close": "Speichern & schließen",
  Type: "Typ",
  Edit: "Bearbeiten",
  Delete: "Löschen",
  "Go back": "Geh zurück",
  "New item": "Neuer Gegenstand",
  Id: "Id",
  "Upload Image": "Bild hochladen",
  "Layouts Timeline": "Layouts-Zeitachse",
  Date: "Datum",
  "Back stage": "Hinter den Kulissen",
  Front: "Vorderseite",
  items: "Artikel",
  "Navigate: Things": "Navigieren: Dinge",
  Orientation: "Orientierung",
  back: "der Rücken",
  front: "Vorderseite",
  gallery: "Galerie",
  preview: "Vorschau",
  New: "Neu",
  search: "Suche",
};
